module.exports = __webpack_public_path__ + "static/media/apptprev.ce806f64.svg";